import type { StoryDoc, WithId } from '@/types';

/**
 * Todas las URLs internas en un solo lugar: cambiar el esquema de rutas no
 * debería obligar a buscar strings por todo el código.
 */
export const routes = {
  home: '/',
  search: '/buscar',
  library: '/biblioteca',
  board: '/tablon',
  thread: (threadId: string) => `/tablon/${threadId}`,
  art: '/galeria',
  artUpload: '/galeria/subir',
  artwork: (artworkId: string) => `/galeria/${artworkId}`,
  notifications: '/notificaciones',
  signIn: '/entrar',
  onboarding: '/bienvenida',
  dashboard: '/panel',
  newStory: '/panel/nueva',
  /**
   * Alta de historia con el fandom ya elegido.
   *
   * Viaja el slug y no el id ni el nombre: el nombre se guarda desnormalizado
   * en cada historia y se usa para buscar, así que no puede venir de la URL
   * —cualquiera la edita— y hay que resolverlo contra el catálogo.
   */
  newStoryInFandom: (slug: string) => `/panel/nueva?fandom=${encodeURIComponent(slug)}`,
  admin: '/moderacion',
  settings: '/ajustes',
  /** Catálogo completo, para mirar antes de escribir. */
  fandoms: '/fandoms',
  fandom: (slug: string) => `/fandom/${slug}`,
  /* Los slugs válidos son las claves de `legalDocs` en i18n/legal.ts. */
  legal: (slug: string) => `/legal/${slug}`,
  terms: '/legal/terminos',
  privacy: '/legal/privacidad',
  takedown: '/legal/autoria',
  profile: (handle: string) => `/@${handle}`,
  story: (handle: string, slug: string) => `/@${handle}/${slug}`,
  chapter: (handle: string, slug: string, index: number) => `/@${handle}/${slug}/${index}`,
  editStory: (storyId: string) => `/panel/historia/${storyId}`,
  editChapter: (storyId: string, chapterId: string) =>
    `/panel/historia/${storyId}/capitulo/${chapterId}`,
} as const;

export function storyPath(story: Pick<WithId<StoryDoc>, 'authorHandle' | 'slug'>): string {
  return routes.story(story.authorHandle, story.slug);
}

export function chapterPath(
  story: Pick<WithId<StoryDoc>, 'authorHandle' | 'slug'>,
  index: number,
): string {
  return routes.chapter(story.authorHandle, story.slug, index);
}
